var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.125,
    width: 28.75,
    height: 28.75,
    rx: 14.375,
    fill: "#4DB748"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8523 21.0341H18.5455V19.7273C18.5455 18.6446 17.6679 17.767 16.5853 17.767H12.6648C11.5822 17.767 10.7046 18.6446 10.7046 19.7273V21.0341H9.39777V19.7273C9.39777 17.9229 10.8605 16.4602 12.6648 16.4602H16.5853C18.3896 16.4602 19.8523 17.9229 19.8523 19.7273V21.0341ZM14.625 15.1534C12.4598 15.1534 10.7046 13.3982 10.7046 11.233C10.7046 9.06775 12.4598 7.3125 14.625 7.3125C16.7902 7.3125 18.5455 9.06775 18.5455 11.233C18.5455 13.3982 16.7902 15.1534 14.625 15.1534ZM14.625 13.8466C16.0685 13.8466 17.2387 12.6764 17.2387 11.233C17.2387 9.78948 16.0685 8.61932 14.625 8.61932C13.1816 8.61932 12.0114 9.78948 12.0114 11.233C12.0114 12.6764 13.1816 13.8466 14.625 13.8466Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.ea145465335792b52076c3e6adf9fc0b.svg";
export { ForwardRef as ReactComponent };